import React from 'react';
import NewDialog from './NewDialog';


export default class BasicDialog extends React.Component{
    render(){
        const {showCancel,content,title,onOk,onCancel,show,okText,cancelText} = this.props;
        return show ?
            <NewDialog showCancel={showCancel}
                       onOk={onOk}
                       onCancel={onCancel}
                       okText={okText}
                       cancelText={cancelText}
            >
                <div className="title" key="0">{title}</div>
                {content}
            </NewDialog>
        : null;
    }
}


// WEBPACK FOOTER //
// ./src/components/Dialog/BasicDialog.js